import * as jwt_decode from "jwt-decode";
import JwtToken from "interfaces/JwtToken";

export default function getAuthToken(): JwtToken | null {

    let token = localStorage.getItem("authorization_token");

    if (token === null) {
        return null;
    }
    return jwt_decode(token) as JwtToken;
}


// WEBPACK FOOTER //
// ./ClientApp/utils/getAuthToken.ts